import { Storybook } from "@tento-ui/ui/storybook";
import { DshTurnAttachment } from "./attachment";

export class DshTurnAttachmentStoryBook extends Storybook.Default {
  title(): string {
    return "Turn dsh · attachment";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "The fixture's attachment — kind word, subject, dim meta",
        render: () =>
          DshTurnAttachment.makeWith({
            label: "session-52738.trace.ljson",
            kind: "file",
            meta: "1.4 MB · 34,430 records",
          }),
      },
      {
        title: "Image",
        render: () =>
          DshTurnAttachment.makeWith({
            label: "shot-plan-round8.png",
            kind: "image",
            meta: "1100×1400",
          }),
      },
      {
        title: "Link — openable, so the whole row activates",
        render: () =>
          DshTurnAttachment.makeWith({
            label: "agentclientprotocol.com/protocol/v1/overview",
            kind: "link",
            onOpen: () => {},
          }),
      },
      {
        title: "Artifact — openable, with a datatype for meta",
        render: () =>
          DshTurnAttachment.makeWith({
            label: "out/news-summary-2026-08-06.md",
            kind: "artifact",
            meta: "news.summary/v1",
            onOpen: () => {},
          }),
      },
      {
        title: "No kind — the category, because the producer did not say",
        render: () =>
          DshTurnAttachment.makeWith({ label: "README.md" }),
      },
      {
        title: "No meta, not openable — a plain line",
        render: () =>
          DshTurnAttachment.makeWith({
            label: "tento-ui-js/components/turn/note.ts",
            kind: "file",
          }),
      },
      {
        title: "A long path — truncated from the left, where the tail names it",
        render: () =>
          DshTurnAttachment.makeWith({
            label:
              "/Users/james/workspace/tento/tento-node-registry/tento-spool.node/html/routes/stream-items.ts",
            kind: "file",
            meta: "10,696 B",
            onOpen: () => {},
          }),
      },
    ];
  }
}
